<button
  type="button"
  class="btn-lote btn-registro"
  (click)="togleTonsPerYardOverlay()"
>
  Toneladas por patio
</button>
<div class="overlay" *ngIf="tonsPerYardOverlay">
  <div class="overlay__content overlay__content--list">
    <div class="table-header mb-0">
      <h2 class="title">
        <span (click)="togleTonsPerYardOverlay()">
          <app-arrow-back></app-arrow-back>
        </span>
        Patios
      </h2>
    </div>
    <p class="form-label">Total de toneladas en patios: {{ totalTons | number : '1.3-3'}} (100%)</p>
    <p class="form-label mb-4">Total de piezas en patios: {{ totalPieces }} (100%)</p>
    <form
      class="locations-grid"
    >
      <div class="d-flex justify-content-between gap-3" *ngFor="let amount of amountsPerYardList">
        <div>
          <label for="{{ 'tonsPerYard' + amount.short_description }}" class="form-label">{{ amount.short_description }}</label>
          <div class="input-group">
            <input
              type="text"
              id="{{ 'tonsPerYard' + amount.short_description }}"
              class="form-control"
              aria-label="Recipient's username"
              aria-describedby="basic-addon2"
              [value]="amount.tonnage | number : '1.3-3'"
              disabled
            />
            <span class="input-group-text" id="basic-addon2">T</span>
          </div>
        </div>
        <div>
          <div class="input-group">
            <input
              type="text"
              id="{{ 'tonsPercentage' + amount.short_description }}"
              class="form-control inputTop"
              aria-label="Recipient's username2"
              aria-describedby="basic-addon3"
              [value]="amount.tonnage_percentage | number : '1.2-2'"
              disabled
            />
            <span class="input-group-text inputTop" id="basic-addon3">%</span>
          </div>
        </div>
        <div>
          <div class="input-group">
            <input
              type="text"
              id="{{ 'piecesPerYard' + amount.short_description }}"
              class="form-control inputTop"
              aria-label="Recipient's username"
              aria-describedby="basic-addon2"
              [value]="amount.pieces"
              disabled
            />
            <span class="input-group-text inputTop" id="basic-addon2">P</span>
          </div>
        </div>
        <div>
          <div class="input-group">
            <input
              type="text"
              id="{{ 'piecesPercentage' + amount.short_description }}"
              class="form-control inputTop"
              aria-label="Recipient's username2"
              aria-describedby="basic-addon3"
              [value]="amount.pieces_percentage | number : '1.2-2'"
              disabled
            />
            <span class="input-group-text inputTop" id="basic-addon3">%</span>
          </div>
        </div>
      </div>
      <div class="grid-all container-button my-5">
        <button type="button" class="btn-lote" (click)="togleTonsPerYardOverlay()">
          Regresar
        </button>
      </div>
    </form>
  </div>
</div>
<app-overlay
  *ngIf="loading"
></app-overlay>
<app-overlay
*ngIf="overlayError"
[reload]="true"
></app-overlay>